import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

export type ViewMode = 'consultor' | 'empresa';

interface ViewModeState {
  mode: ViewMode;
  previewEmpresaId: number | null;

  setMode: (mode: ViewMode) => void;
  setPreviewEmpresaId: (id: number | null) => void;
}

/**
 * Lets a staff account preview the "Visão Empresa" navigation before the
 * dedicated empresa (tenant) login exists. Local-only preference, not tied
 * to the account server-side.
 */
export const useViewModeStore = create<ViewModeState>()(
  persist(
    (set) => ({
      mode: 'consultor',
      previewEmpresaId: null,

      setMode: (mode) => set({ mode }),
      setPreviewEmpresaId: (previewEmpresaId) => set({ previewEmpresaId }),
    }),
    {
      name: 'view-mode-storage',
      storage: createJSONStorage(() => localStorage),
    }
  )
);
